import { render, staticRenderFns } from "./JoinOrganization.vue?vue&type=template&id=e66fdee0"
import script from "./JoinOrganization.vue?vue&type=script&lang=js"
export * from "./JoinOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports